export default require('./CurrentChapter').default
